import { defaultEchartOption } from "./defaultEchartOption";

// Retorna as opções de label do echartOption do preview do gráfico exportado
export function getLabelConfig(theme, checkedOptions) {
  return { 
    ...defaultEchartOption.label,
    show: checkedOptions.percentage,
    color: theme.colors.charts.label.text 
  }
}